if (module.hot && window.location.port !== '8000') {
    module.hot.accept();
}

import 'main/webpack-runtime-settings';
import 'util/fixes';
import { polyfillsAreInstalled, handleErrors } from 'util/polyfills';
import initVue from 'vue/base';

/**
 * Main entry point to the js app. Javascript execution starts here
 * 1. Webpack config and general fixes are initialized via `import` statement
 * 2. Polyfills are imported and asynchronously processed via `Promise` API
 * 3. In case of success, the vue app is initialized
 */
polyfillsAreInstalled
    .then(initVue)
    .catch(handleErrors);



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/main/index.js